import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueMeta from 'vue-meta'
import VueScrollTo from 'vue-scrollto'
import Config from './config/website.config.json'

// Lädt alle Vue-Dateien, die mit BASE, Desktop oder Mobile anfangen und registriert diese.
require('@/plugins/load-globals')

// https://alligator.io/vuejs/vue-media-queries/
require('@/config/breakpoints')

// Globaler Event-Bus
// Beispiel in .vue:
// import { EventBus } from '@/plugins/event-bus.js'
//
// Und entweder
// EventBus.$emit('name-des-events') --> zum Senden
//oder
// EventBus.$on('name-des-events', () => {
//  this.isOpen = true
// }) --> Empfangen
require('./plugins/event-bus')

// website.config.js Global in Vue zur Verfügung stellen
Vue.prototype.$config = Config

// Meta Injection https://www.npmjs.com/package/vue-meta
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
})

Vue.use(VueScrollTo)

Vue.config.productionTip = false

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#app')
